module.exports = __webpack_public_path__ + "img/classify3-active.9e67f4c.png";